import React from 'react';
import OptionButton from '../shared/OptionButton';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RaceConfirmationStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <OptionButton label="Yes" value="Yes" selected={answer === 'Yes'} onClick={onAnswer} />
      <OptionButton label="No" value="No" selected={answer === 'No'} onClick={onAnswer} />
    </div>
  );
};

export default RaceConfirmationStep;
